export default __webpack_public_path__ + "static/media/svg-8.f900138a.svg";